import { render, staticRenderFns } from "./NonConformityAdd.vue?vue&type=template&id=31edf430&scoped=true&"
import script from "./NonConformityAdd.vue?vue&type=script&lang=js&"
export * from "./NonConformityAdd.vue?vue&type=script&lang=js&"
import style0 from "./NonConformityAdd.vue?vue&type=style&index=0&id=31edf430&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31edf430",
  null
  
)

export default component.exports